import { render } from "./dlt-kua.vue?vue&type=template&id=701ac68a&scoped=true"
import script from "./dlt-kua.vue?vue&type=script&lang=js"
export * from "./dlt-kua.vue?vue&type=script&lang=js"

import "./dlt-kua.vue?vue&type=style&index=0&id=701ac68a&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-701ac68a"]])

export default __exports__